import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Popper } from "@mui/material";
import { color } from "../../styles";
import Calendar from "../../svg/Calendar";
import { Dayjs } from "dayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

interface DatePickerWithTimeProps {
    value: Dayjs | null;
    onChange: (newValue: Dayjs | null) => void;
    label?: string;
    disabled?: boolean;
    clearable?: boolean;
    format?: string;
}

const DatePickerWithTime: React.FC<DatePickerWithTimeProps> = ({ value, onChange, label, disabled, clearable, format = "DD/MM/YYYY HH:mm" }: DatePickerWithTimeProps) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
                format={format}
                ampm={format ? false : undefined}
                value={value}
                label={label}
                onAccept={onChange}
                onChange={clearable ? onChange : undefined}
                slotProps={{ field: { clearable, onClear: () => onChange(null) } }}
                minutesStep={1} // Allow 1-minute increments
                viewRenderers={{
                    hours: renderTimeViewClock, // Render clock for hours
                    minutes: renderTimeViewClock, // Render clock for minutes
                    seconds: renderTimeViewClock, // Render clock for seconds (if enabled)
                }}
                disabled={disabled}
                sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                        height: "40px",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "normal",
                        fontFamily: "Noto Sans",
                    },
                    "& .MuiInputBase-input": {
                        padding: "10px",
                    },
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            border: `1px solid ${color.emphasis.NEUTRAL_N90}`,
                            borderRadius: "5px",
                        },
                        "&.Mui-focused fieldset": {
                            border: `1px solid ${color.emphasis.NEUTRAL_N90}`,
                            boxShadow: "0 0 0 2px rgba(0, 88, 160, 0.12)",
                        },
                    },
                    "&.Mui-disabled .MuiIconButton-root, & .MuiInputBase-root.Mui-disabled .MuiIconButton-root": {
                        opacity: 0.5,
                    },
                }}
                slots={{
                    popper: (props) => (
                        <Popper
                            {...props}
                            anchorEl={props.anchorEl}
                            placement="bottom-end"
                            sx={{
                                zIndex: 1300,
                                "& .MuiPickersLayout-root": {
                                    "& .MuiPickersDay-root[aria-selected='true']": {
                                        backgroundColor: color.primary.BLUE_B100,
                                    },
                                },
                            }}
                        />
                    ),
                    openPickerIcon: Calendar,
                }}
            />
        </LocalizationProvider>
    );
};
export default DatePickerWithTime;
